import { toast } from 'react-toastify';

import Alert from './styles';

const ToastAlert = (props) => {
    const options = {
        autoClose: 5000,
        ...props,
    };

    const titles = {
        success: 'Completed!',
        error: 'Failed!',
    };

    let message = '';
    if (props.customMessage) {
        let returnedMessage = props.customMessage?.message;
        if (!returnedMessage || props.customMessage?.message.search('{') !== -1) {
            returnedMessage = `${props.customMessage}`.slice(0, `${props.customMessage}`.search('{'));
        }

        message = returnedMessage || props.message || 'Something went wrong';
    } else {
        message = props.message;
    }

    const AlertComponent = () => (
        <Alert>
            <h3>{titles[props.type]}</h3>
            <p>{message}</p>
        </Alert>
    );

    return toast(props.alertType || AlertComponent, options);
};

export default ToastAlert;
